import { PlusOutlined } from '@ant-design/icons';
import { BasketballSwitchRequest } from '@hefe/models';
import { Button, Col, Row } from 'antd';
import { useAppDispatch } from '../../../../store/store';
import { t } from '@hefe/i18n';
import React, { useState } from 'react';
import CustomList from '../../../core/components/custom-list/custom-list.component';
import SwitchRequestsItemComponent from '../switch-requests-item/switch-requests-item.component';
import { ModalsSlice } from '@hefe/store';

interface SwitchRequestsTabComponentProps {
  requests: BasketballSwitchRequest[];
  userId: number;
  buttons: {
    form: any;
    formId: string;
    title: string;
  }[];
}

export default function SwitchRequestsTabComponent(
  props: SwitchRequestsTabComponentProps
) {
  const { requests, buttons, userId } = props;

  const [showClosedRequests, setShowClosedRequests] = useState(false);

  const openRequests = requests.filter((req) => !req.new_user_id);
  const closedRequests = requests.filter((req) => !!req.new_user_id);

  const dispatch = useAppDispatch();

  const onCreateRequestClick = (title: string, form: any, formId: string) => {
    dispatch(
      ModalsSlice.modalsActions.openModal({
        title: title,
        component: form,
        formId: formId,
      })
    );
  };

  const renderButtons = () => {
    const btns: any[] = [];
    buttons.forEach((button) => {
      btns.push(
        <Button
          key={button.formId}
          type="primary"
          icon={<PlusOutlined />}
          onClick={() =>
            onCreateRequestClick(button.title, button.form, button.formId)
          }
        >
          {button.title}
        </Button>
      );
    });

    return btns;
  };

  const dataSource = showClosedRequests
    ? [...closedRequests, ...openRequests]
    : [...openRequests];

  return (
    <Row gutter={[0, 20]}>
      <Col xs={24}>
        <Button.Group>{renderButtons()}</Button.Group>
      </Col>
      <Col xs={24}>
        <CustomList
          size="default"
          header={
            closedRequests.length > 0 && (
              <Row justify="center">
                <Col span={4}>
                  <Button
                    onClick={() =>
                      setShowClosedRequests((oldValue) => !oldValue)
                    }
                  >
                    {t(
                      `load_more.switch_requests.${
                        showClosedRequests ? 'hide' : 'show'
                      }`
                    )}
                  </Button>
                </Col>
              </Row>
            )
          }
          dataSource={dataSource}
          renderItem={(item: BasketballSwitchRequest) => (
            <SwitchRequestsItemComponent
              key={item.id}
              request={item}
              userId={userId}
            />
          )}
        />
      </Col>
    </Row>
  );
}
